import { render, staticRenderFns } from "./m_readingwrittingfill.vue?vue&type=template&id=b381be50&scoped=true&"
import script from "./m_readingwrittingfill.vue?vue&type=script&lang=js&"
export * from "./m_readingwrittingfill.vue?vue&type=script&lang=js&"
import style0 from "./m_readingwrittingfill.vue?vue&type=style&index=0&id=b381be50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b381be50",
  null
  
)

export default component.exports